import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { REORDER_AREA_ENTRY_STRATEGY } from './actionTypes';
import { reorderAreaEntryStrategySuccessful, reorderAreaEntryStrategyFailed } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

function* reorderAreaEntryStrategy({ payload: { token, strategyId, areas, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.reorderAreaEntryStrategy, {
      token,
      strategyId,
      areas,
    });
    yield put(reorderAreaEntryStrategySuccessful(response.message));
  } catch (error) {
    yield put(reorderAreaEntryStrategyFailed(error));
  }
}

export function* watchReorderAreaEntryStrategy() {
  yield takeEvery(REORDER_AREA_ENTRY_STRATEGY, reorderAreaEntryStrategy);
}

function* reorderAreaEntryStrategySaga() {
  yield all([fork(watchReorderAreaEntryStrategy)]);
}

export default reorderAreaEntryStrategySaga;
